import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "film",
  "use": "film-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"film\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(1 1)\"><rect width=\"16\" height=\"16\" rx=\"2.18\" /><path d=\"M4 0v16m8-16v16M0 8h16M0 4h4m-4 8h4m8 0h4m-4-8h4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol